module.exports = __webpack_public_path__ + "img/icon_dmain3.cac21819.png";